<template>
  <div class="about">
    <v-card class="mx-auto my-2 pa-2">
      <h1>Message Forum</h1>
      <v-data-table
        dense
        :headers="headers"
        :items="items"
        item-key="name"
        class="elevation-1"
      ></v-data-table>
    </v-card>
    <v-card class="mx-auto my-2 pa-2">
      <h1>Feedback</h1>
      <v-btn color="primary" @click="getVote()">Vote MVP</v-btn>
      <v-data-table
        dense
        :headers="headers"
        :items="itemss"
        item-key="name"
        class="elevation-1"
      ></v-data-table>
    </v-card>
  </div>
</template>
<script>
export default {
  data: () => ({
    items: [],
    itemss: [],
    headers: [
      { text: "Sender", value: "sender", width: "10%", align: "center" },
      {
        text: "Message",
        align: "start",
        sortable: false,
        value: "field",
      },
      // { text: 'Fat (g)', value: 'fat' },
      // { text: 'Carbs (g)', value: 'carbs' },
      // { text: 'Protein (g)', value: 'protein' },
      // { text: 'Iron (%)', value: 'iron' },
    ],
  }),
  mounted() {
    this.getMsg();
    this.getFdb();
  },
  methods: {
    getMsg() {
      this.axios
        .get(`${process.env.VUE_APP_API}/api/chats`)
        .then((response) => {
          const payload = response.data;
          // console.log(payload.data);
          this.items = payload.data;
        });
    },
    getFdb() {
      this.axios
        .get(`${process.env.VUE_APP_API}/api/feedbacks`)
        .then((response) => {
          const payload = response.data;
          // console.log(payload.data);
          this.itemss = payload.data;
        });
    },
    getVote() {
      this.axios
        .post(`${process.env.VUE_APP_API}/api/properties/update`)
        .then((response) => {
          const payload = response.data;
          console.log(payload.data);
          // this.itemss=payload.data
        });
    },
  },
};
</script>
